import { Pillar } from '../types/content';

export const valuePillars: Pillar[] = [
  {
    title: 'Go-to-Market & Commercialization',
    description:
      'Building scalable renewable subscription models and customer-centric net new revenue strategies.'
  },
  {
    title: 'Capital Allocation & Venture Partnerships',
    description:
      'Evaluating R&D investments, directing venture capital deal flow, and guiding technology incubation.'
  },
  {
    title: 'Regulatory Strategy & Policy Navigation',
    description:
      'Supporting grid plan refilings, testifying and legal support coordination, and peer utility benchmarking.'
  },
  {
    title: 'Cross-Functional Leadership',
    description:
      'Unifying planning, operations, legal, digital, and commercial teams around long-term growth.'
  }
];
